<template>
  <!-- Супер-заголовок (логический разделитель) -->
  <div v-if="isRoot && visible && !hasModuleName && isSuperHeader">
    <v-list-item disabled class="text-uppercase">
      <v-list-item-title>
        <span :title="title"> {{ title }} </span>
      </v-list-item-title>
    </v-list-item>
    <sv-sidebar-nav-item
      v-for="subNavItem in navItem.children"
      :key="`${subNavItem.kind}-${subNavItem.id}`"
      :ref="`ref_navitem_${subNavItem.id}`"
      :nav-item="removeParent(subNavItem)"
      @activateNode="onPropagateActivateNode"
    />
  </div>

  <!-- Раскрывающийся элемент меню в корне -->
  <v-list-group
    v-else-if="hasChildren && isRoot && visible"
    v-model="expanded"
    no-action
    :prepend-icon="navItem.icon"
    append-icon="mdi-chevron-left"
  >
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>
          <span :title="title"> {{ title }} </span>
        </v-list-item-title>
      </v-list-item-content>
    </template>

    <sv-sidebar-nav-item
      v-for="subNavItem in sortedChildren"
      :key="`${subNavItem.kind}-${subNavItem.id}`"
      :ref="`ref_navitem_${subNavItem.id}`"
      :nav-item="subNavItem"
      @activateNode="onPropagateActivateNode"
    />
  </v-list-group>

  <!-- Кликабельный элемент меню в корне -->
  <v-list-item
    v-else-if="!hasChildren && isRoot && visible && hasModuleName"
    link
    exact
    :to="getWorkplace(navItem)"
    @click="$emit('activateNode')"
  >
    <v-list-item-icon>
      <v-icon>{{ navItem.icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>
        <span :title="title"> {{ title }} </span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>

  <!-- Раскрывающийся элемент меню 2 уровня -->
  <v-list-group
    v-else-if="hasChildren && !isRoot && visible"
    v-model="expanded"
    no-action
    sub-group
    prepend-icon=""
  >
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>
          <span :title="title"> {{ title }} </span>
        </v-list-item-title>
      </v-list-item-content>
    </template>
    <template v-slot:appendIcon>
      <v-icon>mdi-chevron-left</v-icon>
    </template>
    <sv-sidebar-nav-item
      v-for="subNavItem in navItem.children"
      :key="`${subNavItem.kind}-${subNavItem.id}`"
      :ref="`ref_navitem_${subNavItem.id}`"
      :nav-item="subNavItem"
      @activateNode="onPropagateActivateNode"
    />
  </v-list-group>

  <!-- Кликабельный элемент меню 2 и 3 уровня -->
  <v-list-item
    v-else-if="!hasChildren && !isRoot && visible"
    link
    :to="getWorkplace(navItem)"
    @click="$emit('activateNode')"
  >
    <v-list-item-title>
      <span :title="title">{{ title }} </span>
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "SvSidebarNavItem",
  props: {
    navItem: {
      type: Object,
      default: () => ({
        children: []
      })
    }
  },
  data: () => ({
    expanded: false
  }),
  computed: {
    hasChildren() {
      return this.navItem.children && this.navItem.children.length > 0;
    },
    sortedChildren() {
      const sc = [...this.navItem.children];
      sc.sort((a, b) => (a.order || 0) - (b.order || 0));
      return sc;
    },
    isRoot() {
      return !this.navItem.parent_id;
    },
    isSuperHeader() {
      return this.navItem.super_header;
    },
    hasModuleName() {
      return !!this.navItem.workplace;
    },
    visible() {
      return this.navItem.visible;
    },
    title() {
      const { navItem } = this;
      return navItem.title ? navItem.title : navItem.workplace;
    },
    icon() {
      return this.navItem.icon;
    }
  },
  mounted() {
    this.expanded = this.navItem.expanded;
  },
  methods: {
    // Когда получаем событие активации от дочернего элемента меню, который куда-то ведёт,
    // то надо закрыть все соседние раскрытые дочерние вкладки, иначе выглядит слегка некошерно
    onPropagateActivateNode() {
      this.navItem.children.forEach(item => {
        if (item.children?.length) {
          // если это вкладка
          this.$refs[`ref_navitem_${item.id}`][0].collapse();
        }
      });
    },
    collapse() {
      this.expanded = false;
    },
    removeParent(navItem) {
      navItem.pid = null;
      return navItem;
    },
    getWorkplace(navItem) {
      if (navItem.kind == "nav") {
        return { name: navItem.workplace };
      } else if (navItem.kind == "realm_node") {
        const id = navItem.id;
        return { name: navItem.workplace, params: { id } };
      }
    }
  }
};
</script>
